export default "__VITE_ASSET__D3DlHh1M__"